import { styled } from "@mui/system";
import React, { ReactNode, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { brandGradient } from "theme/colors";

interface ProgressBarProps {
  children: ReactNode;
  uploadIsCompleted?: boolean;
  /** Overrides the fill gradient (defaults to the orange→coral brand gradient). */
  gradient?: string;
}

const ProgressWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "progress" && prop !== "gradient",
})<{ progress: number; gradient: string }>(
  ({ progress, gradient }) => ({
    position: "relative",
    width: "100%",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: "2px",
      bottom: 0,
      padding: 0,
      width: `${progress}%`,
      background: gradient,
      borderRadius: "7px",
      zIndex: 1,
      transition: "width 0.2s ease-in-out",
    },
    ".MuiChip-root": {
      zIndex: 2,
      borderRadius: "7px",
      backgroundColor: "transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
    },
  }),
);

const CustomProgressBar: React.FC<ProgressBarProps> = (props) => {
  const [progress, setProgress] = useState(5);

  useEffect(() => {
    if (!props.uploadIsCompleted) {
      setProgress(5);
    }
    let interval: number | undefined;
    if (!props.uploadIsCompleted) {
      interval = window.setInterval(() => {
        setProgress((old) => {
          if (old >= 90) {
            if (interval) window.clearInterval(interval);
            return 90;
          }
          const diff = Math.random() * 10;
          return Math.min(old + diff, 90);
        });
      }, 800);
    } else {
      // complete to 100 when flagged as completed
      setProgress(100);
    }

    return () => {
      if (interval) window.clearInterval(interval);
    };
  }, [props.uploadIsCompleted]);

  return (
    <ProgressWrapper
      progress={props.uploadIsCompleted ? 100 : progress}
      gradient={props.gradient || brandGradient}
    >
      {props.children}
    </ProgressWrapper>
  );
};

export default CustomProgressBar;
